// @ts-nocheck
import {Column} from 'react-table'

import { useIntl } from 'react-intl'; 
import { Facility } from '../../core/_models';
import { HotelCustomHeader } from '../../../../hotel-management/hotel-list/table/columns/HotelCustomHeader';
import { FacilitiesIconHeader } from '../FacilitiesIconHeader';
import { FaciliteActionsCell } from './FacilitieActionsCell';
import { FacilityCustomHeader } from './FacilitieCustomHeader';

const facilitesColumns: ReadonlyArray<Column<Facility>> = [

  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.ICON' })}
        className='min-w-50px'
      />
    ),
    id: 'icon.url',
    Cell: ({...props}) => <FacilitiesIconHeader src={props.data[props.row.index].icon?.url} />, 
  },
  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'translations[0].title',
    Cell: ({ row }) => (
      <span>{row.original.translations?.[0]?.title}</span> 
    ),  },


  {
    Header: (props) => (
      <FacilityCustomHeader tableProps={props} title='' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <FaciliteActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {facilitesColumns}
